<template>
    <div class="personal-ad">
        <loadings v-if="loading"></loadings>

        <template v-else>
            <template v-if='personaLearingStatus==1'>
                <div class="user_info">
                    <div class="left">
                        <img :src="userInfo.portrait"
                             class="avatar"
                             alt="">
                        <div class="info">
                            <strong>{{userInfo.real_name}}</strong>
                            <p>{{userInfo && userInfo.units &&userInfo.units[0]&& userInfo.units[0].school_name || '暂未加入班级'}}</p>
                        </div>
                    </div>
                    <div class="logout"
                         @click="logout">
                        退出
                    </div>
                </div>
                <div class="banner" @click="handleJump('/activity/2023shujia/index')">
                    <img src="../../views/activity/2023shujia/img/h5_banner.png" alt=" " />
                </div>
                <div class="release-personal"
                     v-if="hasMath">
                    <div class="title">
                        发布-数学个性化学习
                    </div>
                    <div class="item"
                         v-for="(item,index) in typeList"
                         @click="handleJump(item.path)"
                         :key="index">
                        <img :src="item.iconUrl"
                             class="type-pic"
                             alt="">
                        <div class="text">
                            <div>
                                <h3>{{item.name}}</h3>
                                <p>{{item.info}}</p>
                            </div>
                            <img src="../../views/math/img/icon_next.png"
                                 alt="">
                        </div>
                    </div>
                </div>
                <div class="release-personal"
                     v-if="hasChinese">
                    <div class="title">
                        发布-语文个性化学习
                    </div>
                    <div class="item"
                         v-for="(item,index) in typeList2"
                         @click="handleJump(item.path)"
                         :key="index">
                        <img :src="item.iconUrl"
                             class="type-pic"
                             alt="">
                        <div class="text">
                            <div>
                                <h3>{{item.name}}</h3>
                                <p>{{item.info}}</p>
                            </div>
                            <img src="../../views/math/img/icon_next.png"
                                 alt="">
                        </div>
                    </div>
                </div>
                <div class="statistics">
                    <div class="statistics_title"><span class="title_icon"></span>本月教学统计</div>
                    <div class="school_list" v-if="taskList.length">
                        <div class="school_item" v-for="sc in taskList" :key="sc.school_id">
                            <div class="school_title">{{ sc.school_name }}</div>
                            <ul class="unit_list" v-for="un in sc.data" :key="un.unit_class_id">
                                <li class="unit_item">
                                    <span>{{ un.unit_name }}</span>
                                    <span>作业已发<span class="orange"> {{ un.real_task_count }} </span>次</span>
                                    <span>通知已发<span class="orange"> {{ un.real_mes_count }} </span>次</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="noMathChinese">
                    目前仅支持语文和数学的个性化学习作业发布，如果您需要发布其他类型作业，请点此下载<a href="http://m.tbkt.cn/">同步课堂</a>APP
                </div>
            </template>
            <template v-else>
                <teaTask></teaTask>
            </template>
            <div class="btm-area">
                <div @click="changeActive(1)"
                     :class="personaLearingStatus==1?'active':''">
                    <img src="./img/icon-home.png"
                         alt="">
                    <img src="./img/icon-home-hover.png"
                         class="hover"
                         alt="">
                    <p>首页</p>
                </div>
                <div @click="verificationVisible = true">
                    <img src="./img/icon_server.png"
                         alt="">
                    <p>服务</p>
                </div>
                <div @click="changeActive(2)"
                     :class="personaLearingStatus==2?'active':''">
                    <img src="./img/icon-done.png"
                         alt="">
                    <img src="./img/icon-done-hover.png"
                         class="hover"
                         alt="">
                    <p>完成情况</p>
                </div>
            </div>
            <verification-code :phoneNumber="userPhone" :visible.sync="verificationVisible" @success="verificationSuccess"></verification-code>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
import teaTask from "COMPONENTS/base/share_tea_taskList.vue";
import verificationCode from "COMPONENTS/VerificationCode.vue";

export default {
    components: {
        loadings,
        teaTask,
        verificationCode
    },

    data () {
        return {
            loading: true,
            userInfo: '',
            userPhone:"",
            typeList: [{
                name: "同步习题",
                info: "课时同步，学生完成后，推送个性化学习报告",
                iconUrl: require('../../views/math/img/icon_exer.png'),
                path: '/sx/testPaper/taskset/21/1'
            },
            {
                name: "每周一测",
                info: "每周一测，学生完成后，推送个性化学习报告",
                iconUrl: require('../../views/math/img/icon_weekend.png'),
                path: '/sx/testPaper/taskset/21/2'
            }, {
                name: "单元复习",
                info: "综合测试，学生完成后，推送个性化学习报告",
                iconUrl: require('../../views/math/img/icon_united.png'),
                path: '/sx/testPaper/taskset/21/3'
            }],
            typeList2: [{
                name: "同步习题",
                info: "课时同步，学生完成后，推送个性化学习报告",
                iconUrl: require('../../views/chinese/img/icon_exer.png'),
                path: '/chinese/select_task/select_chapter/51/0'
            },
            {
                name: "单元复习",
                info: "综合测试，学生完成后，推送个性化学习报告",
                iconUrl: require('../../views/chinese/img/icon_united.png'),
                path: '/chinese/select_task/select_chapter/51/1'
            }],
            personaLearingStatus: this.$store.state.personaLearning.personaLearingStatus,//1;首页，2：完成情况
            hasChinese: false,
            hasMath: false,
            verificationVisible:false,
            taskList:[]
        }
    },
    created () {
        let that = this
        localStorage.removeItem('chinese_send_ok');
        localStorage.removeItem('math_send_ok');
        this.$http.post(API_URL_BASE_API + '/account/profile/').then((res) => {
            if (res.data.response === 'ok') {
                let r = this.userInfo = res.data.data;
                this.userPhone = res.data.data.phone;
                res.data.data.units.forEach(e => {
                    if (e.sid == 21) {
                        this.hasMath = true //有数学
                    } else if (e.sid == 51) {
                        this.hasChinese = true //有语文
                    }
                });
                localStorage.setItem('info', JSON.stringify(r));
                if (r.units.length) {
                    if (r.units[0].city_id == "411600") {
                        localStorage.setItem('city_id', "411600");
                    } else {
                        localStorage.setItem('city_id', "");
                    }
                }
                this.$store.commit('setLoading', false);
            }
        })

        this.$http.post(API_URL_CONFIG_API + '/api/new/home/extra/',{user_type:3}).then((res) => {
            res = res.data;
            if (res.response === 'ok') {
                this.taskList = res.data.task_num_new;
            }
        })


    },
    mounted () {
        this.loading = false
        //修改页面title
        document.title = '个性化学习'

    },
    methods: {
        handleJump (path) {
            this.$router.push(path)
        },
        changeActive (e) {
            this.personaLearingStatus = e
            this.$store.commit('setPersonaLearingStatus', e)
        },
        verificationSuccess(){
            location.href = VUE_URL_GIFT + "/gift?from_task=1&tbkt_token=" + localStorage.getItem("Tbkt-Token");
        },
        /**退出登录 */
        logout () {
            localStorage.clear();
            location.href = WAP_URL + '/qr/special/tealogins?type=3&exit=1';
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.personal-ad {
    padding-bottom: 100px / $ppr;
}
.user_info {
    background: #fff;
    padding: 40px / $ppr 30px / $ppr;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
        display: flex;
        align-items: center;
        .avatar {
            width: 100px / $ppr;
            height: 100px / $ppr;
            border-radius: 100%;
            margin-right: 20px / $ppr;
        }
        .info {
            strong {
                font-weight: bold;
                font-size: 36px / $ppr;
                display: block;
                margin-bottom: 10px / $ppr;
                color: #191919;
            }
            p {
                font-size: 24px / $ppr;
                color: #999999;
            }
        }
    }
    .logout {
        font-size: 20px / $ppr;
        color: #ff8c55;
        background: #fff2ec;
        padding: 11px / $ppr 50px / $ppr;
        border-radius: 48px / $ppr;
        cursor: pointer;
    }
}
.text-area {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 20px / $ppr 20px / $ppr 20px / $ppr 100px / $ppr;

    img {
        position: absolute;
        bottom: 20px / $ppr;
        left: 20px / $ppr;
        width: 44px / $ppr;
    }
    p {
        font-size: 24px / $ppr;
        color: #fff;
        text-align: right;
        text-shadow: 0 5px 5px rgba(0, 0, 0, 0.7);
    }
}
.banner{
    background:#fff;
    padding: 0 20px/$ppr;
    margin-bottom: -24px/$ppr;
    img{
        border-radius: 10px/$ppr;
    }
}
.release-personal {
    background: #fff;
    margin: 24px / $ppr 0;
    .title {
        font-size: 30px / $ppr;
        color: #333;
        font-weight: bold;
        line-height: 120px / $ppr;
        padding-left: 20px / $ppr;
        &:before {
            content: "";
            display: inline-block;
            width: 4px / $ppr;
            height: 28px / $ppr;
            background: #5e89ef;
            border-radius: 2px / $ppr;
            vertical-align: middle;
            margin-right: 10px / $ppr;
            margin-top: -3px / $ppr;
        }
    }
    .item {
        display: flex;
        align-items: center;
        padding: 34px / $ppr 30px / $ppr;
        border-top: 1px / $ppr solid #e8e8e8;
        .type-pic {
            width: 56px / $ppr;
        }
        .text {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 25px / $ppr;
            h3 {
                font-size: 30px / $ppr;
                color: #333;
                font-weight: normal;
                margin-bottom: 10px / $ppr;
            }
            p {
                color: #999;
                font-size: 24px / $ppr;
            }
            img {
                width: 16px / $ppr;
            }
        }
    }
}
.statistics{
    padding: 0 24px/$ppr;
    background-color: #fff;
    .statistics_title{
        padding-top: 30px/$ppr;
        height: 44px/$ppr;
        line-height: 44px/$ppr;
        color: #5e89ef;
        font-size: 36px/$ppr;
        font-weight: bold;
        .title_icon{
            display: inline-block;
            width: 40px/$ppr;
            height: 40px/$ppr;
            background-size: 100% 100%;
            vertical-align: middle;
            margin-top: -6px/$ppr;
            margin-right: 15px/$ppr;
            background-image: url("./img/statistics.png");
        }
    }
    .school_list{
        .school_item{
            padding-top: 19px/$ppr;
            .school_title{
                line-height: 72px/$ppr;
                font-size: 28px/$ppr;
                font-weight: bold;
            }
            .unit_list{
                padding: 0 20px/$ppr 10px/$ppr;
                .unit_item{
                    display: flex;
                    justify-content: space-between;
                    height: 65px/$ppr;
                    align-items: center;
                    font-size: 28px/$ppr;
                    color: #999;
                    .orange{
                        font-weight: bold;
                        color: #f60;
                    }
                }
            }
        }
    }
}
.noMathChinese {
    padding: 40px / $ppr;
    font-size: 24px / $ppr;
    color: #333;
    line-height: 1.7;
    text-align: center;
    a {
        color: #5e89ef;
    }
}
.btm-area {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    border-top: 1px / $ppr solid #e8e8e8;
    display: flex;
    padding: 14px / $ppr 0 10px / $ppr;
    &:before {
        content: "";
        position: absolute;
        width: 1px;
        height: 100%;
        top: -1px;
        left: 50%;
        z-index: 22;
    }
    div {
        flex: 1 0 0;
        text-align: center;
        img {
            width: 40px / $ppr;
            display: block;
            margin: 0 auto;
            margin-bottom: 10px / $ppr;
        }
        p {
            color: #aaa;
            font-size: 20px / $ppr;
            line-height: 1;
        }
    }

    .active {
        img {
            display: none;
        }
        .hover {
            display: block;
        }
        p {
            color: #5e89ef;
        }
    }
    .hover {
        display: none;
    }
}
</style>